import { useCallback, useEffect } from "react";
import { useHistory } from "react-router";

import { useBandContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router/constants";
import { buildUrl } from "shared/utils";
import { useIntercom } from "shared/utils/hooks/useIntercom";

export const useBandRoute = () => {
  const history = useHistory();

  const { setBand, setBandUser } = useIntercom();
  const { bandId, currentBandUser, band } = useBandContext();

  useEffect(() => {
    setBand(band);
    setBandUser(currentBandUser);
  }, [band, currentBandUser, setBand, setBandUser]);

  const pushRoute = useCallback(
    (
      path: string,
      options?: {
        bandId?: string;
        hash?: string;
        params?: Record<string, string>;
        state?: Record<string, any>;
      }
    ) => {
      (bandId || options?.bandId) &&
        history.push(
          buildUrl(
            path,
            {
              bandId: (options?.bandId || bandId) as string,
              ...options?.params,
            },
            options?.hash
          ),
          options?.state
        );
    },
    [bandId, history]
  );

  const getPath = useCallback(
    (
      path: string,
      options?: {
        bandId?: string;
        hash?: string;
        params?: Record<string, string>;
      }
    ) => {
      if (bandId || options?.bandId) {
        return buildUrl(
          path,
          {
            bandId: (options?.bandId || bandId) as string,
            ...options?.params,
          },
          options?.hash
        );
      }
      return BAND_PATHS.HOME;
    },
    [bandId]
  );

  return { pushRoute, getPath };
};
